// I IMPORT THE CSS
import "./App.css";

// I IMPORT COMPONENTS
import Header from "./components/Header";
import HeaderBottom from "./components/HeaderBottom";
import Main from "./components/Main";
import Footer from "./components/Footer";

function App() {
  return (
    <div>
      <Header />
      <HeaderBottom />
      <Main />
      <Footer />
    </div>
  );
}

export default App;
